import { GET_PRODUCT_TYPE_LIST } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_PRODUCT_TYPE_LIST:
            return action.payload;
        default:
            return state;
    }
}